import getLinkHref from '@/modules/utils/api/getLinkHref'
import clientHTTP from '@/modules/clientHTTP'
import constants from '@/configuration/constants'

const createEndDevice = (application, devEui, params = {}) => {
  return clientHTTP.put(getLinkHref(application, 'endDevices') + `/${devEui}`, params)
}

const getEndDevice = (application, devEui) => {
  return clientHTTP.get(getLinkHref(application, 'endDevices') + `/${devEui}`)
}

const getEndDevices = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'endDevices'), params)
}

const patchEndDevice = (endDevice, params = {}, options = {}) => {
  return clientHTTP.patch(getLinkHref(endDevice, 'self'), params, {}, options)
}

const deleteEndDevice = (endDevice) => {
  return clientHTTP.delete(getLinkHref(endDevice, 'self'))
}

const createEndDevicesDeletion = (application, equipments, headers = {}) => {
  return clientHTTP.post(getLinkHref(application, 'createEndDevicesDeletion'), equipments, headers)
}

const getEndDevicesDeletion = (proccessingUrl) => {
  return clientHTTP.get(constants.gmsUrl + proccessingUrl)
}

const createMacCommand = (endDevice, params = {}) => {
  return clientHTTP.post(getLinkHref(endDevice, 'createMacCommand'), params)
}

const getEndDeviceChannels = (endDevice) => {
  return clientHTTP.get(getLinkHref(endDevice, 'endDeviceChannels'))
}

const getEndDeviceDataUp = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'dataUp'), params)
}

const getEndDeviceDataDown = (application, params = {}) => {
  return clientHTTP.get(getLinkHref(application, 'dataDown'), params)
}

const createEndDeviceDataDown = (application, params = {}) => {
  return clientHTTP.post(getLinkHref(application, 'dataDown'), params)
}

const cancelOneDataDown = (dataDown) => {
  return clientHTTP.delete(getLinkHref(dataDown, 'self') + '?cancel=true')
}

const getEndDeviceMessages = (endDevice, params = {}) => {
  return clientHTTP.get(getLinkHref(endDevice, 'endDeviceMessages'), params)
}

const getEndDeviceEvents = (endDevice, params = {}) => {
  return clientHTTP.get(getLinkHref(endDevice, 'endDeviceEvents'), params)
}

const resetEndDeviceFrameCounters = (endDevice) => {
  return clientHTTP.put(getLinkHref(endDevice, 'resetEndDeviceFrameCounters'))
}

const getEndDeviceLastGateways = (endDevice, params = {}) => {
  return clientHTTP.get(getLinkHref(endDevice, 'endDeviceLastGateways'), params)
}

const getEndDeviceLastEvents = (endDevice, params = {}) => {
  return clientHTTP.get(getLinkHref(endDevice, 'endDeviceLastEvents'), params)
}

export default {
  createEndDevice,
  getEndDevice,
  getEndDevices,
  patchEndDevice,
  deleteEndDevice,
  createEndDevicesDeletion,
  getEndDevicesDeletion,
  createMacCommand,
  getEndDeviceChannels,
  getEndDeviceDataUp,
  getEndDeviceDataDown,
  createEndDeviceDataDown,
  cancelOneDataDown,
  getEndDeviceMessages,
  getEndDeviceEvents,
  resetEndDeviceFrameCounters,
  getEndDeviceLastGateways,
  getEndDeviceLastEvents
}
